module.exports = __webpack_public_path__ + "h5/img/newsTitle.5495a1a1.png";